// HOOKS
import { useMutation } from "@apollo/client";
// GRAPHQL
import { DELETE_MANY_PRODUCTS } from "../../graphql/mutations/products/products.mutations";

const useDeleteManyProducts = () => {
  const [deleteProductsMutation, { loading, error, data }] =
    useMutation(DELETE_MANY_PRODUCTS);

  const deleteManyProducts = async (products) => {
    try {
      const res = await deleteProductsMutation({
        variables: {
          products: [...products.map((product) => ({ _id: product._id }))],
        },
      });
      return res?.data?.deleteProducts;
    } catch (error) {
      console.error(`Error deleting products: ${error?.message}`);
      alert(`Error deleting products: ${error?.message}`);
    }
  };

  return { deleteManyProducts, loading, error };
};

export default useDeleteManyProducts;
